import { AppendState as RouterSelectorState } from '@wearejh/m2-pwa-engine/lib/router/router.register';

export const routerSelector = (state: RouterSelectorState) => {
    return {
        isRouteResolving: state.router.resolving,
    };
};

export default routerSelector;
